module.exports = __webpack_public_path__ + "static/shuttleid-complete-package-privacy-policy-updated-august-2025-4e1b7b9bf741394724a8ae5740241051.pdf";